import { useCallback, useEffect, useState } from 'react';
import { useAccount } from '../../contexts/account/AccountContexts';

const useExport = () => {
  const [canExport, setCanExport] = useState<boolean | null>(null);
  const { accountResponse } = useAccount();

  const checkExport = useCallback(async () => {
    const isDownloadDisabled = Boolean(
      accountResponse && !accountResponse.addons.includes('EXPORT_DATA')
    );
    setCanExport(!isDownloadDisabled);
    return !isDownloadDisabled;
  }, [canExport]);

  useEffect(() => {
    checkExport();
  }, []);

  return { canExport, checkExport };
};

export default useExport;
